import React, {useEffect, useState} from 'react';
import styles from './BillingInfoCard.module.css';
import Button from '../../common/button/Button';
import {currentPayAPI, nextPayAPI} from "../../../services/client";
import {PaymentInfoResponseData} from "../../../types/client";
import TextCard from "../../common/textCard/TextCard";
import {useNavigate} from "react-router-dom";

//결제 정보 카드
const BillingInfoCard: React.FC = () => {
    const [current, setCurrent] = useState<PaymentInfoResponseData | null>(null);
    const [next, setNext] = useState<PaymentInfoResponseData | null>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchBillingInfo = async () => {
            try {
                setLoading(true);
                // 가장 최근에 결제한 내역 조회 API
                const currentData = await currentPayAPI();
                setCurrent(currentData);
                //다음 결제 정보 조회 API
                const nextData = await nextPayAPI();
                setNext(nextData);
            } catch (error) {
                console.log(error);
            } finally {
                setLoading(false);
            }
        };
        fetchBillingInfo();
    }, []);

    //결제액 형식 변환, 없을 경우 '-' 출력
    const formatAmount = (amount: number | null | undefined) => {
        if (amount == null) return '-';
        return amount.toLocaleString() + ' 원';
    };

    //요일
    const formatDate = (date: Date | null | undefined, day: number | null | undefined) => {
        if (!date || day == null) return '-';
        const dayOfWeek = ['월', '화', '수', '목', '금', '토', '일'][day - 1] || '';
        return `${date.toString().split("T")[0]}(${dayOfWeek})`;
    };

    //결제 여부 출력, 예정도니 결제가 없을 경우 '-' 출력
    const formatIsPaid = (isPaid: boolean | null | undefined) => {
        if (isPaid == null) return '-';
        return isPaid ? '결제 완료' : '결제 예정';
    }

    //클라이언트 결제 페이지로 이동
    const detail = () => {
        navigate("/client/billing");
    }

    // 헤더 컴포넌트
    const Header = () => (
        <div className={styles.header}>
            <div className={styles.titleContainer}>
                <h1 className={styles.title}>Billing Information</h1>
                <p className={styles.subtitle}>결제 요약 정보</p>
            </div>
            <div className={styles.buttonContainer}>
                {/*결제 상세 버튼*/}
                <Button
                    variant="primary"
                    className={styles.detailButton}
                    onClick={detail}
                >
                    Detailed Information
                </Button>
            </div>
        </div>
    );

    if (loading) {
        return (
            <div className={styles.container}>
                <Header/>
                <div className={styles.body}>
                    <div className={styles.loading}>로딩 중...</div>
                </div>
            </div>
        );
    }

    //지난 결제 정보
    const currentInfo = [
        {
            label: "지난 결제일",
            value: formatDate(current?.paidAt, current?.day),
        },
        {
            label: "결제 금액",
            value: formatAmount(current?.amount),
        },
        {
            label: "결제 상태",
            value: formatIsPaid(current?.isPaid)
        }
    ];

    //다음 결제 정보
    const nextInfo = [
        {
            label: "다음 결제일",
            value: formatDate(next?.paidAt, next?.day),
        },
        {
            label: "결제 금액",
            value: formatAmount(next?.amount),
        },
        {
            label: "결제 상태",
            value: formatIsPaid(next?.isPaid)
        }
    ];

    return (
        <div className={styles.container}>
            {/*헤더*/}
            <Header/>
            <div className={styles.body}>
                {/*결제 정보*/}
                <TextCard items={currentInfo} className={styles.fullWidth}/>
                <TextCard items={nextInfo} className={styles.fullWidth}/>
            </div>
        </div>
    );
};

export default BillingInfoCard;